import { Link } from "react-router-dom";

function SecondaryButton({ children, to, href, className = "", ...rest }) {
  const sharedClassName = `group relative inline-flex items-center justify-center gap-2 rounded-xl border border-brand-navy/25 bg-white px-6 py-3.5 text-sm font-semibold text-brand-navy transition-all duration-300 hover:-translate-y-0.5 hover:border-brand-gold/55 hover:bg-brand-gold-soft/35 hover:text-brand-navy hover:shadow-card focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-gold focus-visible:ring-offset-2 ${className}`.trim();

  if (to) {
    return (
      <Link className={sharedClassName} to={to} {...rest}>
        {children}
      </Link>
    );
  }

  if (href) {
    return (
      <a className={sharedClassName} href={href} {...rest}>
        {children}
      </a>
    );
  }

  return (
    <button className={sharedClassName} type="button" {...rest}>
      {children}
    </button>
  );
}

export default SecondaryButton;
